// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vbtZ","content":"styles_content__P7AhJ","row":"styles_row__1bpCw","footer":"styles_footer__3GLm6","phraseLength":"styles_phraseLength__3DzRr"};